<template>
    <div class="menuitem">
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
            active-text-color="#ffd04b" :unique-opened="true">
            <div v-for="item in filteredRoutes" :key="item.path">
                <el-submenu v-if="item.isSubmenu && hasPermission(item)" :index="item.path">
                    <template slot="title">
                        <i :class="item.meta.icon"></i>
                        <span>{{ item.meta.title }}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item v-if="childitem.isShow && hasPermission(childitem)" :index="childitem.path"
                            v-for="childitem in item.children" :key="childitem.path"
                            @click="openUrl(childitem.name, childitem.path)">{{ childitem.meta.title
                            }}</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-menu-item v-else-if="!item.isSubmenu && hasPermission(item)" :index="item.path"
                    @click="openUrl(item.name, item.path)">
                    <i :class="item.meta.icon"></i>
                    <span slot="title">{{ item.meta.title }}</span>
                </el-menu-item>
            </div>
        </el-menu>
    </div>
</template>

<script>
import port from '@/api/port'
export default {
    computed: {
        routes() {
            return this.$router.options.routes
        },
        filteredRoutes() {
            return this.routes.filter(item => item && item.path)
        }
    },
    data() {
        return {
            userRoles: [],
        }
    },

    created() {
        this.getUserRoule()
    },
    methods: {
        getUserRoule() {
            port.getUserAuth().then(res => {
                if (res.state == 1) {
                    localStorage.setItem('userRole', res.data.role)
                    let roleStr = res.data.role
                    // 2. 如果是空，返回空数组
                    if (!roleStr) return []
                    // 3. 字符串转数组（按逗号分隔）
                    this.userRoles = roleStr.split(',').map(item => item.trim())
                    this.checkCurrentRoutePermission()
                } else {
                    this.$message({
                        message: res.error[0],
                        type: 'error'
                    });
                }
            })
        },
        checkCurrentRoutePermission() {
            const currentRoute = this.$route
            const matchedRoute = this.$router.options.routes.find(route => {
                if (route.path === currentRoute.path) return true
                if (route.children) {
                    return route.children.some(child => child.path === currentRoute.path)
                }
                return false
            })

            let targetRoute = null
            if (matchedRoute) {
                if (matchedRoute.children) {
                    targetRoute = matchedRoute.children.find(child => child.path === currentRoute.path)
                } else {
                    targetRoute = matchedRoute
                }
            }

            // 如果页面需要权限，但用户没有 → 跳首页
            if (targetRoute && targetRoute.roles && !this.hasPermission(targetRoute)) {
                // this.$message.warning('你没有权限访问该页面')
                this.$router.push('/')
            }
        },
        hasPermission(route) {
            if (!route) return false

            if (!route.roles || !Array.isArray(route.roles)) {
                return true
            }

            if (!this.userRoles || this.userRoles.length === 0) {
                return false
            }

            // 正常判断
            return this.userRoles.some(role => route.roles.includes(role))
        },
        openUrl(url, path) {
            this.getUserRoule()
            if (this.$route.path != path) {
                this.$router.push({
                    name: url,
                    params: { url: url, scene: new Date().getTime() }
                })
            }
        }

    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.menuitem {
    width: 160px;
    height: 100vh;

    .el-menu {
        height: 100vh;
    }
}

.el-menu-item {
    min-width: auto !important;
}
</style>
